import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { RawStatsDataMap } from '../types';

const { persistAtom } = recoilPersist();

export const useSpotGammaIVState = atom<boolean>({
  key: 'useSpotGammaIVState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

// Stats

export const currentStatsState = atom<RawStatsDataMap | null>({
  key: 'currentStatsState',
  default: null,
});
